import { MouseEvent } from 'react';

import { T } from 'react-translator-component';

export const orderByName = (list, callback, e: MouseEvent<HTMLDivElement>) => {
  const isOrdered = e.currentTarget.querySelector('.header_icon_gabrr')?.classList.contains('active');

  if (list.length) {
    list.sort((a, b) => {
      const A = !!a.name?.trim() || !a.name ? a.name?.trim().toUpperCase() : 'Sem Nome';
      const B = !!b.name?.trim() || !a.name ? b.name?.trim().toUpperCase() : 'Sem Nome';

      if (A < B) {
        return !isOrdered ? -1 : 1;
      }
      if (A > B) {
        return !isOrdered ? 1 : -1;
      }

      return 0;
    });

    callback(list);
  }
};

export const orderByAddress = (list, callback, e: MouseEvent<HTMLDivElement>) => {
  const isOrdered = e.currentTarget.querySelector('.header_icon_gabrr')?.classList.contains('active');

  if (list.length) {
    list.sort((a, b) => {
      const addressA = a?.address?.street || `${a?.address?.city} ${a?.address?.state}` || T('Undefined');

      const addressB = b?.address?.street || `${b?.address?.city} ${b?.address?.state}` || T('Undefined');

      const A = addressA;
      const B = addressB;

      if (A < B) {
        return !isOrdered ? -1 : 1;
      }
      if (A > B) {
        return !isOrdered ? 1 : -1;
      }

      return 0;
    });
    callback(list);
  }
};

export const orderByExternalId = (list, callback, e: MouseEvent<HTMLDivElement>) => {
  const isOrdered = e.currentTarget.querySelector('.header_icon_gabrr')?.classList.contains('active');

  if (list.length) {
    list.sort((a, b) => {
      const A = !!a.externalId?.trim() || !a.externalId ? a.externalId?.trim().toUpperCase() : 'Sem Nome';
      const B = !!b.externalId?.trim() || !a.externalId ? b.externalId?.trim().toUpperCase() : 'Sem Nome';

      if (A < B) {
        return !isOrdered ? -1 : 1;
      }
      if (A > B) {
        return !isOrdered ? 1 : -1;
      }

      return 0;
    });

    callback(list);
  }
};
